import type { Lang } from '../i18n';

/**
 * Malayalam names for the places venues are listed in.
 *
 * A venue's city is free text stored in English, and it is also the value the
 * filter and the /venues?location= link search on, so it must stay as it is.
 * Only what the visitor reads changes. A place not listed here keeps the name
 * the manager typed, rather than a guessed spelling.
 */
const ML: Record<string, string> = {
  thiruvananthapuram: 'തിരുവനന്തപുരം',
  trivandrum: 'തിരുവനന്തപുരം',
  kollam: 'കൊല്ലം',
  quilon: 'കൊല്ലം',
  pathanamthitta: 'പത്തനംതിട്ട',
  alappuzha: 'ആലപ്പുഴ',
  alleppey: 'ആലപ്പുഴ',
  kottayam: 'കോട്ടയം',
  idukki: 'ഇടുക്കി',
  ernakulam: 'എറണാകുളം',
  kochi: 'കൊച്ചി',
  cochin: 'കൊച്ചി',
  thrissur: 'തൃശ്ശൂർ',
  trichur: 'തൃശ്ശൂർ',
  palakkad: 'പാലക്കാട്',
  palghat: 'പാലക്കാട്',
  malappuram: 'മലപ്പുറം',
  kozhikode: 'കോഴിക്കോട്',
  calicut: 'കോഴിക്കോട്',
  wayanad: 'വയനാട്',
  kannur: 'കണ്ണൂർ',
  cannanore: 'കണ്ണൂർ',
  kasaragod: 'കാസർഗോഡ്',
  kasargod: 'കാസർഗോഡ്',
  kothamangalam: 'കോതമംഗലം',
  muvattupuzha: 'മൂവാറ്റുപുഴ',
  perumbavoor: 'പെരുമ്പാവൂർ',
  aluva: 'ആലുവ',
  guruvayur: 'ഗുരുവായൂർ',
};

/** The name to show for a place in the current language. */
export function placeName(place: string, lang: Lang): string {
  if (lang !== 'ml') return place;
  return ML[place.trim().toLowerCase()] ?? place;
}
